<template>
    <div class="form-content" :ref="stepName" style="position:relative">
        <div class="form-header">
            <p>Je betaling</p>
            <p><span>Ik geef Testaankoop de toestemming om de €2 voor mijn proefperiode te innen door debet van mijn rekeningnummer. Na deze proefperiode wordt mijn abonnement automatisch verlengd en krijg ik de rest van het eerste jaar 50% korting. Ik betaal dan slechts &nbsp;€12,33 per maand in plaats van &nbsp;€24,66 tot ik mijn uitdrukkelijke toestemming intrek.</span></p>
        </div>
        <PaymentOptinForm></PaymentOptinForm>
        <b-loading :is-full-page="false" v-model="loading"></b-loading>

        <p class="paytrust-text">Je bent vrij om je abonnement op ieder moment op te zeggen.</p>
        <img class="paytrust-img" src="/images/fr_multigift/pay-trust.png" alt="Universal SSL">
    </div>
</template>

<script>
import mixin from "../../../travel_step_mixin";
import {Button} from "../../../../../../models/fields/Button";
import PaymentOptinForm from "./PaymentOptinForm";
import animation_engine_mixin from "../../../animation_engine_mixin";
import animation_step_style_mixin from "../../../animation_step_style_mixin";

export default {
    components: {PaymentOptinForm},
    mixins: [mixin,  animation_engine_mixin, animation_step_style_mixin],
}
</script>
